import React, {useEffect, useState} from 'react';
import {getTime} from '../../../requests/timer';

function secondsToCountdownTime(totalSeconds) {
	const secondsInMinute = 60;
	const secondsInHour = 60 * secondsInMinute;
	const secondsInDay = 24 * secondsInHour;

	const days = Math.floor(totalSeconds / secondsInDay);
	totalSeconds %= secondsInDay;

	const hours = Math.floor(totalSeconds / secondsInHour);
	totalSeconds %= secondsInHour;

	const minutes = Math.floor(totalSeconds / secondsInMinute);
	totalSeconds %= secondsInMinute;

	const seconds = totalSeconds;

	return {
		days,
		hours,
		minutes,
		seconds,
	};
}

const Timer = () => {
	const [remainingTime, setRemainingTime] = useState({});

	const handleRemainingTime = () => {
		try {
			getTime().then((time) => {
				setRemainingTime(time.data.remainingTime);
			});
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			setRemainingTime((prevTimeData) => {
				const {days, hours, minutes, seconds} = prevTimeData;
				const timeInSeconds =
					days * 24 * 60 * 60 +
					hours * 60 * 60 +
					minutes * 60 +
					seconds;
				const newValueInSeconds = timeInSeconds - 1;
				return secondsToCountdownTime(
					newValueInSeconds < 0 ? 0 : newValueInSeconds
				);
			});
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	useEffect(() => {
		handleRemainingTime();
	}, []);

	return (
		<>
			<div className='flex justify-center w-full h-20 select-none'>
				<div className='absolute flex bg-slate-200 justify-between items-center w-36 h-12 shadow-xl rounded'>
					{Object.entries(remainingTime).map((timeArray, i) => {
						const timeValue = timeArray[1].toString();
						const timeId = timeArray[0][0];
						return (
							<div
								key={timeValue + i}
								className='grid text-center h-full w-full'
							>
								<span
									key={timeId}
									className='font-light text-black w-full'
								>
									{timeValue.length === 1
										? '0' + timeValue
										: timeValue ?? 0}
								</span>
								<span
									key={timeId + timeValue}
									className='uppercase text-xs font-bold text-center'
								>
									{timeId === 'h' ? 'g' : timeId}
								</span>
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default Timer;
